export const autoSetupCategories = [
  'loot',
  'experience',
  'itemLevel',
  'composition',
  'randomness',
  'equality',
] as const

export type AutoSetupCategory = typeof autoSetupCategories[number]

export const requireBuffsOptions = [
  'none',
  'major_buffs',
  'all_buffs',
  'all_classes',
] as const

export type RequireBuffsOption = typeof requireBuffsOptions[number]

// Classic buffs don't map to the live major/standard tiers, so only these two apply.
export const classicRequireBuffsOptions: RequireBuffsOption[] = [
  'none',
  'all_classes',
]

type AutoSetupSettings = {
  weights: Record<AutoSetupCategory, number>
  prioritiseNewPlayers: boolean
  newPlayerCap: number | null
  allowAltsOffspecs: boolean
  prioritiseRaidPlanValidity: boolean
  requireBuffs: RequireBuffsOption
  priorityTeamRankIds: number[]
  requiredCharacterIds: number[]
}

export const requireBuffsOptionsForGameVersion = (
  gameVersion: string,
): RequireBuffsOption[] =>
  gameVersion === 'live' ? [...requireBuffsOptions] : classicRequireBuffsOptions

export default AutoSetupSettings
